export default "__VITE_ASSET__CryJliB9__"